import gql from 'graphql-tag';

export default gql`
  mutation adminDeleteOrganization($organizationId: ID!) {
    adminDeleteOrganization(organizationId: $organizationId)
  }
`;
